import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {EnvironmentService} from '@epg-apps/environment-api';
import {CustomerService} from '@epg-apps/customer-api';
import {combineLatest, Observable, tap} from 'rxjs';
import {
  CustomerDetail,
  DetailedEnvironment,
  VersionInfo,
} from '@epg-apps/cdh-models';
import {VersionInfoService} from '@epg-apps/versioninfo-api';

@Injectable({
  providedIn: 'root',
})
export class DetailedEnvironmentResolver implements Resolve<
  [CustomerDetail, DetailedEnvironment, VersionInfo]
> {
  environmentService = inject(EnvironmentService);
  customerService = inject(CustomerService);
  versionInfoApiService = inject(VersionInfoService);

  resolve(
    route: ActivatedRouteSnapshot,
  ): Observable<[CustomerDetail, DetailedEnvironment, VersionInfo]> {
    const customerId = route.params['customerId'];
    const environmentId = route.params['environmentId'];

    return combineLatest([
      this.customerService.getCustomerDetails(customerId),
      this.environmentService.getDetailedEnvironmentById(environmentId),
      this.versionInfoApiService.getVersionInfo(),
    ]).pipe(
      tap(([customerDetail, environmentDetail, versionInfo]) => {
        this.customerService.setCustomerDetails(customerDetail);
        this.environmentService.setDetailedEnvironment(environmentDetail);
        this.versionInfoApiService.setVersionInfo(versionInfo);
      }),
    );
  }
}
